export const SITE_DOMAIN   = 'carriercheck.eu';
export const SUPPORT_EMAIL = 'support@carriercheck.eu';
export const INFO_EMAIL    = 'info@carriercheck.eu';
export const SALES_EMAIL   = 'sales@carriercheck.eu';
